import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import "@/App.css";
import IntroOverlay from "@/components/landing/IntroOverlay";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import CostOfDelay from "@/components/landing/CostOfDelay";
import OpportunityEngine from "@/components/landing/OpportunityEngine";
import RevenueLeakMap from "@/components/landing/RevenueLeakMap";
import HowItWorks from "@/components/landing/HowItWorks";
import RevenueRoadmap from "@/components/landing/RevenueRoadmap";
import Packages from "@/components/landing/Packages";
import ClientPortalPreview from "@/components/landing/ClientPortalPreview";
import Philosophy from "@/components/landing/Philosophy";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import StickyCTA from "@/components/landing/StickyCTA";

const INTRO_KEY = "apexflow_intro_seen";

export default function App() {
  const [showIntro, setShowIntro] = useState(false);
  const [ready, setReady] = useState(true);

  useEffect(() => {
    let seen = false;
    try {
      seen = window.localStorage.getItem(INTRO_KEY) === "1";
    } catch (e) {
      seen = false;
    }
    if (!seen) {
      setShowIntro(true);
      setReady(false);
    }
  }, []);

  const finishIntro = () => {
    try {
      window.localStorage.setItem(INTRO_KEY, "1");
    } catch (e) {
      /* storage unavailable — intro simply replays next time */
    }
    setShowIntro(false);
    setReady(true);
  };

  return (
    <div className="App bg-white text-brand-black font-sans antialiased">
      <AnimatePresence>{showIntro && <IntroOverlay key="intro" onComplete={finishIntro} />}</AnimatePresence>
      <span id="top" />
      <Header />
      <main>
        <Hero ready={ready} />
        <CostOfDelay />
        <OpportunityEngine />
        <RevenueLeakMap />
        <HowItWorks />
        <RevenueRoadmap />
        <Packages />
        <ClientPortalPreview />
        <Philosophy />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}
